import React, { useState } from 'react';
import { Container, Row, Col, Form, Button, Card } from 'react-bootstrap';
import { Mail, Phone, MapPin, Clock } from 'lucide-react';
import { collection, addDoc} from "firebase/firestore";
 import { db } from "../firebase";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await addDoc(collection(db, "inquiries"), {
        name: formData?.name,
        email: formData?.email,
        subject: formData?.subject,
        message: formData?.message
      });

      // toast({ title: 'Success', description: 'Category added successfully!' });

      setFormData({ name: '', email: '', subject: '', message: '' });

    } catch (err) {
      console.error("Error sending inquiry:", err);
    }

  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <div className="py-5">
      <Container>
        {/* Header */}
        <div className="text-center mb-5">
          <h1 className="fw-bold mb-3">Contact Us</h1>
          <p className="lead text-muted">Have questions? We'd love to hear from you!</p>
        </div>

        <Row className="mb-5">
          {/* Contact Info */}
          <Col lg={4} className="mb-4 mb-lg-0">
            <Card className="border-0 shadow-sm mb-3">
              <Card.Body className="d-flex align-items-center p-4">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#E3F2FD',
                    flexShrink: 0
                  }}
                >
                  <Phone size={28} style={{ color: '#2196F3' }} />
                </div>
                <div>
                  <h6 className="fw-bold mb-1">Phone</h6>
                  <p className="text-muted mb-0 small">+1 (555) 123-4567</p>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm mb-3">
              <Card.Body className="d-flex align-items-center p-4">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#FFF3E0',
                    flexShrink: 0
                  }}
                >
                  <Mail size={28} style={{ color: '#a5cb89' }} />
                </div>
                <div>
                  <h6 className="fw-bold mb-1">Email</h6>
                  <p className="text-muted mb-0 small">support@focopet.com</p>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm mb-3">
              <Card.Body className="d-flex align-items-center p-4">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#F3E5F5',
                    flexShrink: 0
                  }}
                >
                  <MapPin size={28} style={{ color: '#9C27B0' }} />
                </div>
                <div>
                  <h6 className="fw-bold mb-1">Address</h6>
                  <p className="text-muted mb-0 small">123 Pet Street, Animal City, AC 12345</p>
                </div>
              </Card.Body>
            </Card>

            <Card className="border-0 shadow-sm">
              <Card.Body className="d-flex align-items-center p-4">
                <div
                  className="rounded-circle d-flex align-items-center justify-content-center me-3"
                  style={{
                    width: '60px',
                    height: '60px',
                    backgroundColor: '#E8F5E9',
                    flexShrink: 0
                  }}
                >
                  <Clock size={28} style={{ color: '#4CAF50' }} />
                </div>
                <div>
                  <h6 className="fw-bold mb-1">Business Hours</h6>
                  <p className="text-muted mb-0 small">Mon-Fri: 9AM-6PM</p>
                </div>
              </Card.Body>
            </Card>
          </Col>

          {/* Contact Form */}
          <Col lg={8}>
            <Card className="border-0 shadow-sm">
              <Card.Body className="p-4">
                <h4 className="fw-bold mb-4">Send us a Message</h4>
                <Form onSubmit={handleSubmit}>
                  <Row className="g-3">
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Your Name *</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="John Doe"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Email Address *</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="john@example.com"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Subject *</Form.Label>
                        <Form.Control
                          type="text"
                          name="subject"
                          value={formData.subject}
                          onChange={handleChange}
                          placeholder="How can we help you?"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Form.Group>
                        <Form.Label className="fw-bold small">Message *</Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={6}
                          name="message"
                          value={formData.message}
                          onChange={handleChange}
                          placeholder="Write your message here..."
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={12}>
                      <Button
                        type="submit"
                        size="lg"
                        style={{
                          backgroundColor: '#a5cb89',
                          border: 'none',
                          borderRadius: '8px',
                          padding: '12px 40px'
                        }}
                      >
                        Send Message
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Contact;